import React from 'react';
import { logEvents } from '../../data/console';
import type { LogEvent } from '../../types/console';
function LogRow({
  event
}: {
  event: LogEvent;
}) {
  const blocked = event.outcome === 'blocked';
  return <li className="flex items-center gap-2.5 border-b border-hairline px-3 py-1.5 text-[10.5px]" data-id="element-46" data-mp="2h656o5pt5z7m">
      <span className="w-12 shrink-0 font-mono text-[9.5px] text-subtle" data-id="element-47" data-mp="2l65x6oq6m0v1">{event.time}</span>
      <span className="w-[108px] shrink-0 font-semibold text-body" data-id="element-48" data-mp="38w9xon82pkht">{event.source}</span>
      <span className="flex-1 truncate text-muted" data-id="element-49" data-mp="3dvcvbmlq4ofr">{event.description}</span>
      <span className={`shrink-0 rounded-full border px-[7px] py-[3px] text-[8.5px] font-bold tracking-[0.04em] ${blocked ? 'border-alert/40 bg-alert/10 text-alert' : 'border-secure/30 bg-secure/10 text-secure'}`} data-id="element-50" data-mp="3dt8pv086fhdd">
        {blocked ? 'BLOCKED' : 'SECURED'}
      </span>
    </li>;
}
export function IntrusionLog() {
  return <div className="flex-1 overflow-hidden rounded-[10px] border border-line bg-panel py-2" data-id="element-51" data-mp="1tdon1qqf9z67">
      <div className="mb-1 flex items-center justify-between border-b border-hairline px-3 pb-1.5" data-id="element-52" data-mp="369lgsqx22ss0">
        <h3 className="text-[10px] font-semibold uppercase tracking-[0.05em] text-muted" data-id="element-53" data-mp="31aio85y9if0x">
          Intrusion event log
        </h3>
        <span className="text-[10px] font-semibold uppercase tracking-[0.05em] text-muted" data-id="element-54" data-mp="3b6ve0sqos8qe">
          Real-time
        </span>
      </div>
      <div className="relative h-[106px] overflow-hidden" data-id="element-55" data-mp="3p523bkhkl0eg">
        <ul className="animate-log-scroll" data-id="element-56" data-mp="3k7jr9l89a528">
          {[...logEvents, ...logEvents].map((event, i) => <LogRow key={`${event.time}-${i}`} event={event} data-id="element-57" data-mp="2rbnw2lbb6fk" data-mpi={i} />)}
        </ul>
      </div>
    </div>;
}